import http from '../../../utils/http'

export const getActivityList = params => {
  return http({
    url: '/coupon/getCouponOperateActivity',
    params
  })
}

export const getReactivePicInfo = params => {
  return http({
    url: '/coupon/getReactivePicInfo',
    params
  })
}
